import { createApp, reactive } from "vue";
import Guide from "./guide.vue";

const divDom = document.createElement("div");

divDom.setAttribute("class", "loading-container");

const options = reactive({
  showToast: true,
  type: 3,
  opacity: 1,
  targetElement: null
});

const $Guide = createApp(Guide, { options }).mount(divDom);

const guidePlugin = {
  show({ type, opacity, targetElement }) {
    options.showToast = true;
    options.opacity = opacity || 0.3;
    options.targetElement = targetElement;
    options.type = type
    // 检查是否传入了目标元素，若有，则插入到该元素的下方
   
      // 如果没有指定 targetElement，默认插入到 body 中
      document.body.appendChild($Guide.$el);
    
  },
  hide() {
    options.showToast = false;
  },
};

export default {
  install(app) {
    app.config.globalProperties.$guide = guidePlugin;
  }
};
